/*
 * Copyright (c) 2021. Datafood srl
 * Developed by Revo Digital - revodigital.it
 * ---
 * Author: leonardoviada
 * File: Header.tsx
 * Project: mle-client
 * Committed last: 2021/10/27 @ 1819
 * ---
 */

import {
  Button,
  Icon,
  Intent,
  Menu,
  MenuDivider,
  MenuItem,
  Navbar,
  NavbarDivider,
  NavbarGroup,
  NavbarHeading,
  Tag
}                                   from '@blueprintjs/core';
import { Popover2 }                 from '@blueprintjs/popover2';
import { useDispatch, useSelector } from 'react-redux';
import { RootState }                from '../store';
import { logout }                   from '../store/actions/auth-actions';
import React                        from 'react';
import { SupportMenu }              from './common/menus/SupportMenu';

export const Header = (props: { setChangelogIsOpen: (state: boolean) => any }) => {
  const authData = useSelector((state: RootState) => state.authState);
  const dispatch = useDispatch();

  const userMenu = (
    <Menu>
      <div className="m-2">
        <div className="text-lg flex flex-row">
          <div>
            { `${ authData.user.firstName }` }
          </div>
          <Tag className="ml-2" intent={ Intent.SUCCESS }>
            <Icon icon="home" className="mr-2"/>
            { authData.user.company?.name }</Tag>
        </div>
        <MenuDivider />
        <div className="flex flex-row my-2">
          <Icon icon="envelope"/>
          <div className="ml-1">{ authData.email }</div>
        </div>
      </div>
      <MenuItem disabled icon="user" text="Gestisci account"/>
      <MenuDivider/>
      <MenuItem icon="log-out" text="Logout"
                onClick={ () => dispatch(logout()) }/>
    </Menu>
  );

  return (
    <Navbar>
      <NavbarGroup>
        <NavbarHeading className="font-semibold">MLEditor</NavbarHeading>
      </NavbarGroup>
      <NavbarGroup align="right">
        <Popover2 autoFocus={ false } content={ userMenu }>
          <Button minimal icon="user"/>
        </Popover2>
        <Button disabled minimal icon="notifications"/>
        <Button disabled minimal icon="cog"/>
        <NavbarDivider/>
        <Button
          minimal
          icon="automatic-updates"
          onClick={ () => props.setChangelogIsOpen(true) }
          small
        >
          <div className="bp4-text-muted">Changelog</div>
        </Button>
        <NavbarDivider/>
        <Popover2
          position="bottom-right"
          autoFocus={ false }
          content={ <SupportMenu/> }
        >
          <Button minimal icon="help"/>
        </Popover2>
      </NavbarGroup>
    </Navbar>
  );
};
